import React from "react";

export default function NotFound(){
    return (
    <div className="container-fluid text-gray">
        <h3>Oops, something went wrong, please try again!</h3>
    </div>
    )
}